<div class="row task-single-page">
  <div class="info-view btm-margin">
    <div class="column medium-12 large-12 indy-tables badge-tables">
      <app-tracker-paginated-table [setObj]="tableData" *ngIf="hasTasks" (onRowAction)="handleTasksTableAction($event)" (onSort)="sortByColumn($event)"
                               (onScroll)="handleScroll($event)" (onInputSearchSelection)="optionSelected($event)"
                               (onInputBlur)="updateInput($event)" (onStatusMove)="moveNextStatus($event)"></app-tracker-paginated-table>
    </div>
    <div class="column medium-7 large-7" style="padding-right: 0;margin-bottom: 7rem" *ngIf="taskSinglePostData">
      <app-post-wrapper [singlePostId]="taskPostId" [taskId]="taskId" [taskSinglePostData]=taskSinglePostData [taskSinglePost] = true></app-post-wrapper>
    </div>
    <div class="column medium-5 large-5" style="padding-left: 0" *ngIf="singlePageviewChecklist && trackerName">
      <app-check-list [data]="checklistData" [taskId]="taskId" [trackerName]="trackerName" [singlePageviewChecklist]="singlePageviewChecklist" [isTaxPlanningTask]="isTaxPlanningTask" (triggerNavigateToCreateTodo)="navigateToCreateTodo($event)"></app-check-list>
    </div>
    <div class="column medium-5 large-5 todo-table" style="padding: 0" *ngIf="showTodos">
      <div class="column medium-6">
        <label style="font-size: 18px; color: #878787;margin-left: 13px;">Client ToDo's:</label>
      </div>
      <div class="column medium-6 text-right">
        <span class="pointer add-share-buttons" (click)="addTodo()"><i class="material-icons">add_circle</i></span>
      </div>
      <div class="column medium-12 zero-padding" *ngIf="resetTodoTable">
        <app-task-todos [taskId]="singlePageTaskData[0].id" [trackerSinglePageData]="todoData" [isTaxPlanningTask]="isTaxPlanningTask"></app-task-todos>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addTodo']">
  <div [ngClass]="{'tpiq-reveal': reveal['addTodo']}" class="reveal-overlay" (click)="hideReveal('addTodo')"></div>
  <div [ngClass]="{'tpiq-reveal': reveal['addTodo']}" class="reveal tax-strategy-reveal" style="width: 45%;padding: 0;border: 1px;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Add ToDo</span>
      <span (click)="hideReveal('addTodo')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row" style="margin-top: 1rem;padding-left: 10px" *ngIf="isTaxPlanningTask">
        <div class="small-2 columns" style="margin-top: 10px">
          <label class="" style="color: #878787">Select Todo</label>
        </div>
        <div class="small-8 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="taxStrategyTodos" [includeNone]="false" [setPlaceHolder]="'Select a Todo'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setTaxStrategyTodo($event)" [setDefaultValue]="selectedTaxStrategyTodo"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row" style="margin-top: 1rem;padding-left: 10px">
        <div class="small-2 columns" style="margin-top: 10px">
          <label class="" style="color: #878787">Title</label>
        </div>
        <div class="small-8 columns">
          <input type="text" [(ngModel)]="todoTitle"/>
        </div>
      </div>
      <div class="row" style="padding-left: 10px">
        <div class="small-2 columns" style="margin-top: 10px;">
          <label class="" style="color: #878787">Due Date</label>
        </div>
        <div class="small-3 columns">
          <input class="round-border" type="text" tpiq-custom-datepicker [format]="dateFormat" [mindate]="'past'" (valueChanged)="setDueDate($event)" [ngModel]="todoDuedate" placeholder="Due Date" style="border-radius: 10px">
        </div>

        <div class="small-2 columns" style="margin-top: 10px;">
          <label class="" style="color: #878787">Priority</label>
        </div>
        <div class="small-3 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="priorities" [setPlaceHolder]="'Priority'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setPriority($event)" [setDefaultValue]="todoPriority"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row" style="padding-left: 10px;margin-top: 15px">
        <div class="small-2 columns">
        </div>
        <div class="small-8 columns">
          <div style="border: 1px solid  #cacaca !important;padding: 10px;color: #0a0a0a !important;" [froalaEditor]="todoDescriptionEditorOptions"  [(froalaModel)]="todoDesc"></div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-12">
          <div class="small-6 medium-2" style="margin-left: 1rem">
            <label for="globalNativeFileUpload">
              <span style="cursor: pointer"><i class="material-icons" style="font-size: 18px;color: #878787;vertical-align: middle">attach_file</i>Attach File</span>
            </label>
          </div>
          <input type="file" id="globalNativeFileUpload" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
        </div>
        <div class="small-12 medium-12">
          <div class="file-upload-modal">
            <section>
              <div class="row files-to-upload-section">
                <div class="small-12 medium-12 columns" style="padding-left: 0px;margin-left: -10px">
                  <ul *ngIf="uploader.queue.length>0" style="list-style-type: none;">
                    <li *ngFor="let item of uploader.queue">
                      <div class="row">
                        <div class="column small-10 medium-10" [ngClass]="{'item-uploaded':item.isSuccess}">
                                                <span *ngIf="!(item.isReady || item.isUploading || item.isSuccess)">
                                                    <i class="ion-ios-cloud-upload-outline" (click)="item.upload()"></i>
                                                </span>{{ item?.file?.name }} &nbsp;({{ item?.file?.size/1024/1024 | number:'.2' }} MB)
                        </div>
                        <div class="column small-2 text-right">
                          <i *ngIf="(item.isUploading)" class="ion-ios-close-outline" (click)="item.cancel()"></i>
                          <i class="ion-ios-minus-outline" (click)="removeUploadItem(item)"></i>
                        </div>
                      </div>
                      <div *ngIf="item.isUploading">
                        <div class="progress">
                          <div class="progress-meter" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="small-12 medium-5 attachment" *ngFor="let attachment of attachments" style="margin-left: 2rem;margin-top: 7px">
          <div class="row">
            <div class="medium-9 commonColor2  pointer">
              <div class="attachment_name" style="overflow: hidden;text-overflow: ellipsis;display: inherit;white-space: nowrap;" (click)="downloadDocument(attachment.id, 'preview')">{{attachment.name}}</div>
            </div>
            <div class="column medium-3 attach-icons" style="padding: 0px">
              <i class="icon ion-ios-cloud-download-outline commonColor2 float-right" (click)="downloadDocument(attachment.id)"></i>
              <i class="icon ion-ios-trash commonColor2 float-right" style="padding-right: 8px" (click)="removeAttachment(attachment)"></i>

            </div>
          </div>
        </div>
      </div>
      <div class="text-right" style="margin-top: 2rem">
        <button class="button small" (click)="createTodo()">CREATE</button>
        <button class="button small" style="background-color: white !important;color: #878787;" (click)="hideReveal('addTodo')">CANCEL</button>
      </div>
    </div>
  </div>
</div>
